import React from "react";
import cname from "./style.module.scss";
import TubeContentsList from "./Content/TubeContentsList";

import {
  FullscreenModal,
  CloseButton,
} from "@learningblocks/storybook-components/lib/FullscreenModal";

/**
 * Props for the InspectTubeModal component
 */
interface InspectTubeModalProps {
  /**
   * Whether the modal window is open
   */
  isOpen: boolean;
  /**
   * Function to call when closing the modal window
   */
  onClose: () => void;
  /**
   * Whether the notebook is collapsed
   */
  notebookCollapsed: boolean;
  /**
   * size of  header
   */
  size: "sm" | "md" | "lg";
  /**
   * Whether the modal is open for dispensing liquid
   */
  isDispense: boolean;
}

/**
 * InspectTubeModal:
 *  - Give user general info on Spectrophotometer and
 *    its working
 */
export function InspectTubeModal({ ...props }: InspectTubeModalProps) {
  return (
    <FullscreenModal
      isOpen={props.isOpen}
      className={`${cname.inspectTubeModal}`}
      notebookExpanded={!props.notebookCollapsed}
      close={props.onClose}
    >
      <div className={cname.backButton}>
        <CloseButton close={props.onClose} backLabel="Lab" />
      </div>
      <div className={cname.container}>
        <div className={cname.section}>
          <TubeContentsList />
        </div>
      </div>
    </FullscreenModal>
  );
}
